import Place from "../../../models/place";
import MapViewData from "@/models/map-view-data";
import Download from "@/fragments/forms/map-form/components/download/Download";
import marker from "../../../assets/img/place_black_36.svg";
import myLocation from "../../../assets/img/my_location.svg";
import keyboard from "../../../assets/img/keyboard_double.svg";
import right from "../../../assets/img/right.svg";
import dotmarker from "../../../assets/img/circle.svg";
import GeoUtils from "../../../support/geo-utils";
import Toaster from "@/fragments/toaster/Toaster";
import { isEmpty } from "lodash";
import GiraLogo from "../../../assets/img/giraLogo.png";
import { Directions } from '@/support/ors-api-runner'
import OrsParamsParser from '@/support/map-data-services/ors-params-parser'
import toGpx from 'togpx'
import toKml from 'tokml'
import constants from '@/resources/constants'
export default {
  data: () => ({
    GiraLogo,
    dotmarker,
    right,
    keyboard,
    myLocation,
    marker,
    dialog: true,
    settingsModal: false,
    places: [new Place()],
    place: "",
    place2: "",
    textfield2: false,
    calculate: false,
    localModel: null,
    focused: false,
    focusedsecond: false,
    dangeruousPoints: "4",
    routedrowdirection: true,
    checkPlaceData: [],
    checkplacevalue: false,
    checkplace2value: false,
    navigationButton: false,
    navigationStopButton: false,
    checkRoutedrawplacetwo: false,
    countryCheck: false,
    ratingModal: false,
    rating: 0,
    currSeconds: 0,
    timer: 0,
    showLoading: false,
    giraStationRoute: false,
    giratogglebutton: false,
    routeSwapFieldOne: null,
    routeSwapFieldSecond: null,
    routeCheckMobile:false,
    showSecondTextFeild:false,
    swapButtonToggle :true,
    hostportData:false,
    inserthostportlink:true,
    // noSleep: new NoSleep(),
    noSleepVideo:null,
    noSleepVideoInterval:null,
    removeAccidentHostpot: null,
    approachingDangerous : false,

    isDownloadModalOpen: false,
    downloadFileName: 'CycleAI-Route',
    downloadFileName: null,
    downloadFormat: null,
    defaultDownloadName: 'CycleAI-Route'
  }),
  props: {
    model: {
      Type: Place,
      Required: true
    },
    mapViewData: {
      Type: MapViewData,
      Required: true
    },
    requestArgs: {
      Type: Object,
      Required: true
    },
    downloadFormatsSupported: {
      Type: Array,
      default: function () {
        return ['json', 'ors-gpx', 'geojson', 'to-gpx', 'gpx', 'kml']
      }
    }
  },
  components: {
    Download,
    appToaster: Toaster
  },
  computed: {
    showSuggestion() {
      let show = this.focused;
      return show;
    },
    showSuggestion1() {
      let show = this.focusedsecond;
      return show;
    },
    showBrowserLocationInPlacesList() {
      return this.focused;
    },
    showAreaIcon(place) {
      let show =
        place.properties.layer === "country" ||
        place.properties.layer === "region";
      return show;
    },
    placeSuggestions() {
      // if (!this.focused) {
      //   return []
      // }
      let suggestions = [];
      // if (this.localModel.nameIsCoord()) {
      // const lnglatArr = this.localModel.getLngLatArr()
      // const rawCoordinatesPlace = new Place(lnglatArr[0], lnglatArr[1], this.localModel.placeName, { properties: { layer: 'rawCoordinate' } })
      // rawCoordinatesPlace.rawCoordinate = true
      // suggestions.push(rawCoordinatesPlace)
      // }
      // localStorage.setItem('history_search', JSON.stringify([]));
      let get_coockie = localStorage.getItem("history_search");
      if (get_coockie !== "") {
        var convert_arrays = JSON.parse(get_coockie);
        if (convert_arrays.length !== 0) {
          convert_arrays &&
            convert_arrays.map(data => {
              suggestions.push(data);
            });
        }
      }
      // suggestions = suggestions.concat(this.localModel.suggestions)

      return suggestions;
    },
    downloadFormats () {
      return [
        { text: 'ORS JSON', value: 'json', ext: 'json' },
        { text: 'GeoJSON', value: 'geojson', ext: 'json' },
        { text: 'ORS API GPX', value: 'ors-gpx', ext: 'gpx' },
        { text: `${this.$t('download.standard')} GPX`, value: 'to-gpx', ext: 'gpx' },
        { text: 'KML', value: 'kml', ext: 'kml' }
      ]
    },
    /**
     * Return the name of the route first's point
     * @returns string
     */
    originName () {
      const origin = this.mapViewData.places[0]
      return origin ? origin.placeName : ''
    },
    /**
     * Return the name of the route last's point
     * @returns string
     */
    destinationName () {
      const destination = this.mapViewData.places[this.mapViewData.places.length - 1]
      return destination ? destination.placeName : ''
    },
    availableDownloadFormats () {
      const context = this
      const available = this.lodash.filter(this.downloadFormats, (f) => {
        return context.downloadFormatsSupported.includes(f.value)
      })
      return available
    }
  },
  methods: {
    // focus function 
    inputFocused(event) {
      if(this.routeSwapFieldSecond !== null) {
        this.eventBus.$emit('centerMapFouseTextfield', this.routeSwapFieldSecond)
      }
      this.eventBus.$emit('hostportModalCloseOpenDropdwon',true)
      // this.textfield2 = true
      if (this.place !== null && this.place.length !== 0) {
        this.focused = false;
      } else {
        this.focused = true;
      }
      this.focusedsecond = false;
      // setTimeout(() => {
      //     this.eventBus.$emit('dynamicHight');
      //   }, 500);
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
        this.eventBus.$emit("dynamicWidth");
      }, 50);
      // document.getElementsByClassName("text-fields1")[0].style.marginBottom = "50px";
    },
     // focus function 
    inputFocusedsecond(event) {
      if(this.routeSwapFieldOne !== null) {
        this.eventBus.$emit('centerMapFouseTextfield', this.routeSwapFieldOne)
      }
      this.eventBus.$emit('hostportModalCloseOpenDropdwon',true)
      if (this.place2 !== null && this.place2.length !== 0) {
        this.focusedsecond = false;
      } else {
        this.focusedsecond = true;
      }
      this.focused = false;
      // setTimeout(() => {
      //     this.eventBus.$emit('dynamicHight');
      //   }, 500);
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
        this.eventBus.$emit("dynamicWidth");
      }, 50);
      // document.getElementsByClassName("text-fields2")[0].style.marginBottom = "50px";
    },
    mobileViewCheck() {
      if (this.$lowResolution) {
        this.dialog = true;
      }
    },
    // remove marker
    placeCleared() {
      setTimeout(() => {
        this.focused = true;
        this.eventBus.$emit("removemarkerfirst");
        this.routeSwapFieldSecond = null
      }, 100);
    },
    // remove marker
    placeClearedsecond() {
      setTimeout(() => {
        this.focusedsecond = true;
        this.eventBus.$emit("removemarkersecond");
        this.routeSwapFieldOne = null
      }, 100);
    }, 
    // set getDangerous Point value
    dangeruousValue(value) {
      let getDangerousPoint = localStorage.getItem('getDangerousPoint');
      let setDangerousPoint;
      if(getDangerousPoint === null) {
        setDangerousPoint = localStorage.setItem('setOldDangerousPoint','3');
      }
      else {
        setDangerousPoint = localStorage.setItem('setOldDangerousPoint',getDangerousPoint);
      }
      var data_obj = {
        value: value,
        check_poligone: this.isDanger
      };
      this.$store.commit('dangeruousPoints', value)
      this.dangeruousPoints = value;
      localStorage.setItem("getpoint", value);
      this.eventBus.$emit("testp", data_obj);
    },
    // Route Draw
    routedrow() {
      this.$gtag.event("calculate-route-click", {
        event_category: "route",
        event_label: "Calculate safest route clicked",
        value: "routeClikedCounts"
      });
      
      if (
        this.checkPlaceData.length === 2 &&
        !isEmpty(this.checkPlaceData[0]) &&
        !isEmpty(this.checkPlaceData[1]) &&
        this.place !== null &&
        this.place2 !== null &&
        this.place.length > 0 &&
        this.place2.length > 0
      ) {
        this.eventBus.$emit("toggleRoundTripmobile");
        this.routedrowdirection = false;
      }
    },
    // hide setting modal
    hidesettingmodal() {
      this.$gtag.event("dismiss_settings_modal", {
        event_category: "settings",
        event_label: "Settings modal dismissed clicks",
        value: "dismiss_settings_modal_click"
      });

      this.settingsModal = false;
      this.dialog = true;
      this.eventBus.$emit("settingsButton");
      setTimeout(() => {
        this.dynamicHight();
      }, 50);
    },
    // select current location
    setLocationFromBrowser() {
      GeoUtils.getBrowserLocation()
        .then(location => {
          // context.$store.commit('currentLocation', location)
          // context.myLocationActive = showLocation

          // Set returned location as map center
          // const latlng = GeoUtils.buildLatLong(location.lat, location.lng)
          const placeName = "Your location";
          const place = new Place(location.lng, location.lat, placeName, {
            properties: { layer: "venue" }
          });
          this.routeSwapFieldSecond = place;
          this.eventBus.$emit("GoogleAPI", place, 1);
          this.eventBus.$emit("RoutePlaceSecond", place);
          this.eventBus.$emit("girastationsecond", {
            lat: place.lat,
            lng: place.lng
          });
          this.place = place.placeName;
          this.textfield2 = true;
          this.focused = false;
          this.focusedsecond = false;
          this.showSecondTextFeild = true;
          this.routedrowdirection = true;
          // if(this.routeCheckMobile) {
          //   this.routedrowdirection = true;
          // }
          if (this.place !== "" && this.place2 !== "") {
            this.calculate = true;
          }
          // this.setMapCenter(latlng)
        })
        .catch(error => {
          // const message = this.getPositionErrorMessage(error)
          // context.showWarning(message, { timeout: 0 })
          // context.myLocationActive = false
          // console.log(error)
        });
    },
    // select current location
    setLocationFromBrowsersecond() {
      GeoUtils.getBrowserLocation()
        .then(location => {
          // context.$store.commit('currentLocation', location)
          // context.myLocationActive = showLocation

          // Set returned location as map center
          // const latlng = GeoUtils.buildLatLong(location.lat, location.lng)
          const placeName = "Your location";
          const place = new Place(location.lng, location.lat, placeName, {
            properties: { layer: "venue" }
          });
          this.routeSwapFieldOne = place;
          this.eventBus.$emit("GoogleAPI", place, 0);
          this.eventBus.$emit("RoutePlaceOne", place);
          this.eventBus.$emit("girastationone", {
            lat: place.lat,
            lng: place.lng
          });
          // this.place2 = place.placeName
          this.eventBus.$emit("destinationPlace", place.placeName);
          this.eventBus.$emit("currentlatlngobj", place);
          this.eventBus.$emit("placelatlngobj", place);
          this.calculate = true;
          this.focused = false;
          this.focusedsecond = false;
          

          setTimeout(() => {
            this.dynamicHight();
            this.dynamicWidth();
            // this.eventBus.$emit('currentLocationUpdate')
          }, 50);
          if (this.place !== "" && this.place2 !== "") {
            this.calculate = true;
          }
          this.checkplace2value = false;
          // this.setMapCenter(latlng)
        })
        .catch(error => {
          // const message = this.getPositionErrorMessage(error)
          // context.showWarning(message, { timeout: 0 })
          // context.myLocationActive = false
          // console.log(error)
        });
       
        this.routedrowdirection = true;
    },
    selectSuggestion(placeSuggestions) {
      let places = new Place(
        placeSuggestions.lng,
        placeSuggestions.lat,
        placeSuggestions.placeName,
        {
          properties: {
            layer: placeSuggestions.properties.layer,
            country: placeSuggestions.properties.country
          }
        }
      );
      this.routeSwapFieldSecond = places;
      this.eventBus.$emit("GoogleAPI", places, 1);
      this.eventBus.$emit("RoutePlaceSecond", places);
      this.eventBus.$emit("girastationsecond", {
        lat: places.lat,
        lng: places.lng
      });
      this.place = places.placeName;
      this.focused = false;
      this.textfield2 = true;
      this.showSecondTextFeild = true;
      if(this.routeCheckMobile) {
        this.routedrowdirection = true;
      }
      setTimeout(() => {
        this.dynamicHight();
        this.dynamicWidth();
      }, 50);
      if (this.place !== "" && this.place2 !== "") {
        this.calculate = true;
      }
      this.checkplacevalue = false;
    },
    selectSuggestionsecond(placeSuggestions) {
      let places = new Place(
        placeSuggestions.lng,
        placeSuggestions.lat,
        placeSuggestions.placeName,
        {
          properties: {
            layer: placeSuggestions.properties.layer,
            country: placeSuggestions.properties.country
          }
        }
      );
      this.routeSwapFieldOne = places;
      this.eventBus.$emit("GoogleAPI", places, 0);
      this.eventBus.$emit("RoutePlaceOne", places);
      this.eventBus.$emit("girastationone", {
        lat: places.lat,
        lng: places.lng
      });
      this.eventBus.$emit("placelatlngobj", places);
      this.place2 = places.placeName;
      this.focusedsecond = false;
      this.calculate = true;
      this.routedrowdirection = true;
      setTimeout(() => {
        this.dynamicHight();
        this.dynamicWidth();
      }, 50);
      if (this.place !== "" && this.place2 !== "") {
        this.calculate = true;
      }
      this.checkplace2value = false;
    },
    // key up call function
    changed(event = null) {
      document.getElementsByClassName("text-fields1")[0].style.marginBottom =
        "150px";
      if (event) {
        this.focused = false;
        const isPasteEvent = event instanceof ClipboardEvent;
        let pacclasslengh = document.getElementsByClassName("pac-container")
          .length;
        // for (let index = 0; index < pacclasslengh; index++) {
        //   document
        //     .getElementsByClassName("pac-container")
        //     [index].setAttribute("style", "display:block !important;");
        // }
      }
      if (this.place.length !== 0) {
        if (this.checkPlaceData.length !== 0) {
          // if (this.checkPlaceData[0].placeName !== '') {
          //     this.checkPlaceData.splice(0, 1)
          // }
        }
      } else {
        document.getElementsByClassName("text-fields1")[0].style.marginBottom =
          "0px";
        this.focused = true;
      }
    },
    // key up call function
    changedsecond(event = null) {
      document.getElementsByClassName("text-fields2")[0].style.marginBottom =
        "150px";
      if (event) {
        this.focusedsecond = false;
        const isPasteEvent = event instanceof ClipboardEvent;
      }
      if (this.place2.length !== 0) {
        if (this.checkPlaceData.length !== 0) {
          // if (this.checkPlaceData[1].placeName !== '') {
          //     this.checkPlaceData.splice(1, 1)
          // }
        }
      } else {
        document.getElementsByClassName("text-fields2")[0].style.marginBottom =
          "0px";
        this.focusedsecond = true;
      }
    },
    myFunction() {
      this.focused = false;
    },
    // calculate dynamic height
    dynamicHight() {
      // setInterval(() => {
      if (this.$lowResolution) {
        var offsetHeight = document.getElementsByClassName("mobileViewOnly")[0]
          .offsetHeight;
        if (offsetHeight === 0) {
          offsetHeight = document.getElementsByClassName("secondDiv")[0]
            .offsetHeight;
        }
        if(this.place2 !== 'Your location' || this.routedrowdirection === true)
        {
          document
          .getElementsByClassName("my-location-btn")[0]
          .setAttribute("style", "bottom:" + (offsetHeight + 5) + "px;");
        document
          .getElementsByClassName("buttom-set-mobile")[0]
          .setAttribute("style", "bottom:" + (offsetHeight + 10) + "px;");
        }
        else {
          document
            .getElementsByClassName("my-location-btn")[0]
            .setAttribute("style", "bottom:" + (offsetHeight + 5) + "px;");
          document
            .getElementsByClassName("buttom-set-mobile")[0]
            .setAttribute("style", "bottom:" + (offsetHeight + 10) + "px;");
        }
        // document.getElementsByClassName('navigation-class')[0].setAttribute("style", "bottom:" + (offsetHeight + 10) + "px;")
        // document.getElementsByClassName('buttom-set-mobile')[0].style.bottom = offsetHeight + 15+"px"
      }
      // }, 500);
    },
    // calculate dynamic height when on navigation mode
    dynamicHightNavigation() {
      // setInterval(() => {
      if (this.$lowResolution) {
        var offsetHeight = document.getElementsByClassName("mobileViewOnly")[0]
          .offsetHeight;
        if (offsetHeight === 0) {
          offsetHeight = document.getElementsByClassName("secondDiv")[0]
            .offsetHeight;
        }
        document
          .getElementsByClassName("my-location-btn")[0]
          .setAttribute("style", "bottom:" + (offsetHeight + 65) + "px;");
        document
          .getElementsByClassName("buttom-set-mobile")[0]
          .setAttribute("style", "bottom:" + (offsetHeight + 70) + "px;");
        // document.getElementsByClassName('navigation-class')[0].setAttribute("style", "bottom:" + (offsetHeight + 10) + "px;")
        // document.getElementsByClassName('buttom-set-mobile')[0].style.bottom = offsetHeight + 15+"px"
      }
      // }, 500);
    },
    // calculate dynamic width
    dynamicWidth() {
      var offsetHeight = document.getElementsByClassName("mobileViewOnly")[0]
        .offsetHeight;
      if (offsetHeight === 0) {
        offsetHeight = document.getElementsByClassName("secondDiv")[0]
          .offsetHeight;
      }
      let offsetWigth = document.getElementsByClassName("side-left")[0]
        .offsetWidth;
      let offsetWigth1 = document.getElementsByClassName("down")[0].offsetWidth;
      document
        .getElementsByClassName("navigation-class")[0]
        .setAttribute(
          "style",
          "left:0px;bottom:" +
            (offsetHeight + 10) +
            "px"
        );
      // document
      //   .getElementsByClassName("navigation-class")[1]
      //   .setAttribute(
      //     "style",
      //     "left:0px;bottom:" +
      //       (offsetHeight + 10) +
      //       "px"
      //   );
    },
    // text feild blur this call function
    checkplaceinputvalue() {
      if(this.place === null || this.place.length === 0) {
        this.textfield2 = false;
      }
      setTimeout(() => {
        if (this.checkPlaceData.length !== 0) {
          if (
            this.checkPlaceData[1].placeName === null &&
            this.checkPlaceData[1].placeName === undefined
          ) {
            this.checkplacevalue = true;
          } else {
            this.checkplacevalue = false;
          }
        } else {
          if (this.place !== "") {
            this.checkplacevalue = true;
          }
        }
        document
          .getElementsByClassName("text-fields1")[0]
          .setAttribute("style", "marginBottom:unset;");
        document
          .getElementsByClassName("text-fields2")[0]
          .setAttribute("style", "marginBottom:unset;");
        // setTimeout(() => {
          this.dynamicHight();
        // }, 100);
      }, 100);
    },
    // text feild blur this call function
    checkplace2inputvalue() {
      setTimeout(() => {
        if (this.checkPlaceData.length !== 0) {
          if (isEmpty(this.checkPlaceData[1])) {
            this.checkplace2value = true;
          } else {
            this.checkplace2value = false;
          }
        } else {
          if (this.place2 !== "") {
            this.checkplace2value = true;
          }
        }
        document
          .getElementsByClassName("text-fields1")[0]
          .setAttribute("style", "marginBottom:unset;");
        document
          .getElementsByClassName("text-fields2")[0]
          .setAttribute("style", "marginBottom:unset;");
        // setTimeout(() => {
          this.dynamicHight();
        // }, 100);
      }, 100);
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d * 1000;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    // start navigation mode
    navigationStopmethod() {
      this.eventBus.$emit('removeActiveLocation')
      // this.noSleepVideo = document.createElement("video");

      // this.noSleepVideo.setAttribute("title", "CycleAI | Route Planner");
      // this.noSleepVideo.setAttribute("playsinline", "");
      // this.noSleepVideo.setAttribute("loop", "");
      var source = document.createElement("source");
      source.src = "data:video/mp4;base64,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"
      // source.type = 'video/mp4';
      // this.noSleepVideo.appendChild(source);
      // this.noSleepVideoInterval = setInterval(() => {
      //   this.noSleepVideo.play();
      // }, 5000);
      this.settingsModal = false;
      this.eventBus.$emit("settingsButtonhidenavigation");
      this.eventBus.$emit("inputPlacehide");
      this.navigationButton = false;
      this.navigationStopButton = true;
      this.eventBus.$emit("setsecondyourlication");
      this.eventBus.$emit("currentLocationUpdate");
      this.eventBus.$emit("menuToggle", false);
      this.eventBus.$emit("settings", false);
      this.eventBus.$emit('navigationMode', true);

      let currentLocation = this.$store.getters.currentLocation;
      let accident = this.$store.getters.AccidentHostpot;
      this.removeAccidentHostpot = setInterval(() => {
        accident && accident.map(data => {
          const placeDistanceInKM = this.getDistanceFromLatLonInKm(
            currentLocation.lat,
            currentLocation.lng,
            data.position.lat,
            data.position.lng
          ).toFixed(0);
          if(placeDistanceInKM <= 40){
            this.approachingDangerous = true
            setTimeout(() => {
              this.approachingDangerous = false
            }, 1500);
          }
        })
        }, 3000);
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
        this.dynamicHightNavigation();
        this.dynamicWidth();
      }, 500);
    },
    // stop navigation mode
    navigationStartMethod() {
      // this.noSleepVideo.pause();
      // clearInterval(this.noSleepVideoInterval)
      clearInterval(this.removeAccidentHostpot)
      // this.noSleep.disable();
      this.eventBus.$emit("inputPlaceshow");
      this.navigationButton = true;
      this.navigationStopButton = false;
      this.eventBus.$emit("menuToggle", true);
      this.eventBus.$emit("settings", true);
      this.eventBus.$emit("updatelocationclear");
      this.eventBus.$emit('navigationMode', false);
      // if (localStorage.getItem("user_id") !== null) {
      // } else {
        if(localStorage.getItem('analysis') === 'true') { 
          this.ratingModal = true;
        }
      // }
      this.eventBus.$emit("setdirectioncenter");
      setTimeout(() => {
        document.getElementsByClassName('v-dialog__content--active')[1].setAttribute("style","z-index:190;")
      }, 200);
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
        // this.dynamicHightNavigation();
        this.dynamicWidth();
      }, 350);
    },
    // Iphone orientation permission 
    iosPermission() {
      DeviceOrientationEvent.requestPermission()
        .then(response => {
          if (response === "granted") {
            window.addEventListener("deviceorientation", handler, true);
          } else {
            alert("has to be allowed!");
          }
        })
        .catch(e => console.log("not supported", e));
    },
    resetTimer() {
      /* Hide the timer text */

      /* Clear the previous interval */
      // clearInterval(this.timer);

      /* Reset the seconds of the timer */
      this.currSeconds = 0;

      /* Set a new interval */
      if (this.navigationStopButton) {
      } else {
        // this.timer = setInterval(this.startIdleTimer, 600000);
      }
    },
    ratingfunction() {
      window.addEventListener("load", this.resetTimer, true);
      window.addEventListener("click", this.resetTimer, true);
      window.addEventListener("mousemove", this.resetTimer, true);
      window.addEventListener("mousedown", this.resetTimer, true);
      window.addEventListener("touchstart", this.resetTimer, true);
      window.addEventListener("keypress", this.resetTimer, true);
    },
    startIdleTimer() {
      /* Increment the
                timer seconds */
      this.currSeconds++;
      if (localStorage.getItem("user_id") !== null) {
      } else {
        this.ratingModal = true;
      }
      // alert('hii')
    },
    // Rating API call
    ratingSet(value) {
      this.ratingModal = false;
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );

      fetch(
        "https://routeplanner.cycleai.net/api/rate?user_id=" +
          uuid +
          "&rating=" +
          value,
        {
          method: "GET",
          headers: { "Content-Type": "text/plain" }
        }
      )
        .then(response => response.json())
        .then(json => {
          localStorage.setItem("user_id", uuid);
        })
        .catch(err => console.log(err));
    },
    // hostpot toggle function
    hostportdata(event) {
      if (event === true) {
        this.hostportData = true
        this.eventBus.$emit("mobilehosportStatus", true);
        this.eventBus.$emit("HostportStatus", true);
        if (document.getElementsByClassName("hosport-marker").length > 0) {
          let hostport = document.getElementsByClassName("hosport-marker")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("hosport-marker")
              [index].setAttribute(
                "style",
                "visibility:visible !important;cursor:pointer;"
              );
          }
        }
        this.eventBus.$emit('addHostport');
        if (document.getElementsByClassName("circle-change").length > 0) {
          let hostport = document.getElementsByClassName("circle-change")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("circle-change")
              [index].setAttribute(
                "style",
                "display:block;"
              );
          }
        }
      } else {
        this.hostportData = false
        this.eventBus.$emit("mobilehosportStatus", false);
        this.eventBus.$emit("HostportStatus", false);
        if (document.getElementsByClassName("hosport-marker").length > 0) {
          let hostport = document.getElementsByClassName("hosport-marker")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("hosport-marker")
              [index].setAttribute("style", "visibility:hidden !important");
          }
        }
        this.eventBus.$emit('removeHostport');
        if (document.getElementsByClassName("circle-change").length > 0) {
          let hostport = document.getElementsByClassName("circle-change")
            .length;
          for (let index = 0; index < hostport; index++) {
            document
              .getElementsByClassName("circle-change")
              [index].setAttribute(
                "style",
                "display:none;"
              );
          }
        }
      }
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
      }, 300);
    },
    // Gira toggle function
    giradata(event) {
      if (event === true) {
        this.eventBus.$emit("giraRouteDraw");
        this.giratogglebutton = true;
        this.eventBus.$emit("checkGiraStationStatus", true);
        // if (document.getElementsByClassName("gira-marker").length > 0) {
        //   let hostport = document.getElementsByClassName("gira-marker").length;
        //   for (let index = 0; index < hostport; index++) {
        //     document
        //       .getElementsByClassName("gira-marker")
        //       [index].setAttribute("style", "display:block;cursor:initial;");
        //   }
        // }
        this.eventBus.$emit('addGira');
      } else {
        this.eventBus.$emit("simpleRouteDraw");
        this.giratogglebutton = false;
        this.eventBus.$emit("checkGiraStationStatus", false);
        // if (document.getElementsByClassName("gira-marker").length > 0) {
        //   let hostport = document.getElementsByClassName("gira-marker").length;
        //   for (let index = 0; index < hostport; index++) {
        //     document
        //       .getElementsByClassName("gira-marker")
        //       [index].setAttribute("style", "display:none");
        //   }
        // }
        this.eventBus.$emit('removeGira');
      }
    },
    // gira station route draw
    dotlinecss(event) {
      if (event === true) {
        if (
          document.getElementsByClassName("gira_station_route").length > 0 &&
          this.giraStationRoute
        ) {
          let gira = document.getElementsByClassName("gira_station_route")
            .length;
          for (let index = 0; index < gira; index++) {
            document
              .getElementsByClassName("gira_station_route")
              [index].setAttribute("style", "display:block;");
          }
        }
      } else {
        if (document.getElementsByClassName("gira_station_route").length > 0) {
          let gira = document.getElementsByClassName("gira_station_route")
            .length;
          for (let index = 0; index < gira; index++) {
            document
              .getElementsByClassName("gira_station_route")
              [index].setAttribute("style", "display:none;");
          }
        }
      }
    },
    // route Swap function
    swapRouteMobile() {
      this.eventBus.$emit('removePlaceMarkerSelectPlace')
      setTimeout(() => {
        this.dynamicHight();
      }, 800);
      this.swapButtonToggle = false
      if (
        (this.place2 !== null &&
        this.place2.length !== 0) ||
        (this.place !== null &&
        this.place.length !== 0)
      ) {
        let firstfield = this.place;
        this.place = this.place2;
        this.place2 = firstfield;

        if (
          (this.routeSwapFieldOne !== null &&
          this.routeSwapFieldOne !== undefined) ||
          (this.routeSwapFieldSecond !== null &&
          this.routeSwapFieldSecond !== undefined)
        ) {
          let routeObjOne = this.routeSwapFieldOne;
          this.routeSwapFieldOne = this.routeSwapFieldSecond;
          this.routeSwapFieldSecond = routeObjOne;

          if(this.routeSwapFieldOne !== null && this.routeSwapFieldOne !== undefined) {
            this.eventBus.$emit("GoogleAPI", this.routeSwapFieldOne, 0);
            this.eventBus.$emit("RoutePlaceOne", this.routeSwapFieldOne);
            this.eventBus.$emit("girastationone", {
              lat: this.routeSwapFieldOne.lat,
              lng: this.routeSwapFieldOne.lng
            });
          }
          if(this.routeSwapFieldSecond !== null && this.routeSwapFieldSecond !== undefined) {
            this.eventBus.$emit("GoogleAPI", this.routeSwapFieldSecond, 1);
            this.eventBus.$emit("RoutePlaceSecond", this.routeSwapFieldSecond);
            this.eventBus.$emit("girastationsecond", {
              lat: this.routeSwapFieldSecond.lat,
              lng: this.routeSwapFieldSecond.lng
            });
          }
          this.eventBus.$emit("placelatlngobj", this.routeSwapFieldOne);
          setTimeout(() => {
            
            if (
              this.routeSwapFieldOne !== null &&
              this.routeSwapFieldOne !== undefined &&
              this.routeSwapFieldSecond !== null &&
              this.routeSwapFieldSecond !== undefined
            ) {
              if(this.routeSwapFieldOne !== 'Your location') {
                this.eventBus.$emit('navigationStop')
              }
              if(this.routeSwapFieldOne === 'Your location') {
                this.eventBus.$emit('navigationStart')
              }
              this.routedrowdirection = true
              // this.eventBus.$emit("toggleRoundTripmobile");
            }
          }, 500);
        }
      }
    },
    setEventListeners() {
      this.eventBus.$on('removeInsertHostportLinkClickable', () => {
        this.inserthostportlink = true
      });
      this.eventBus.$on('routeCheckMobile',(value) => {
        this.routeCheckMobile = value;
      })
      this.eventBus.$on("routeSwapFieldSecond", data => {
        this.routeSwapFieldSecond = data;
      });
      this.eventBus.$on("giraStationRouteMobile", () => {
        this.giraStationRoute = true;
        if (this.giratogglebutton) {
          this.dotlinecss(true);
        } else {
          this.dotlinecss(false);
        }
      });
      this.eventBus.$on("textfieldshow", () => {
        this.textfield2 = true;
      });
      this.eventBus.$on("calculateButtom", () => {
        this.calculate = true;
      });
      this.eventBus.$on("calculateButtomhide", () => {
        this.calculate = false;
      });
      this.eventBus.$on("dynamicHight", () => {
        this.dynamicHight();
      });
      this.eventBus.$on("dynamicWidth", () => {
        this.dynamicWidth();
      });
      this.eventBus.$on("dangeruousPointsMobile", value => {
        this.dangeruousPoints = value;
      });
      this.eventBus.$on("settingsviewshow", () => {
        this.settingsModal = true;
        this.dialog = false;
        setTimeout(() => {
          var offsetHeight1 = document.getElementsByClassName("secondDiv")[0]
            .offsetHeight;
          let offsetWigth = document.getElementsByClassName("side-left")[0]
            .offsetWidth;
          let offsetWigth1 = document.getElementsByClassName("down")[0]
            .offsetWidth;
          if(this.place2 !== 'Your location' || this.routedrowdirection === true) {

            document
              .getElementsByClassName("my-location-btn")[0]
              .setAttribute("style", "bottom:" + (offsetHeight1 + 5) + "px;");
            document
              .getElementsByClassName("buttom-set-mobile")[0]
              .setAttribute("style", "bottom:" + (offsetHeight1 + 10) + "px;");
            document
              .getElementsByClassName("navigation-class")[0]
              .setAttribute(
                "style",
                "left:0px;bottom:" +
                  (offsetHeight1 + 10) +
                  "px"
              );
            // document
            //   .getElementsByClassName("navigation-class")[1]
            //   .setAttribute(
            //     "style",
            //     "left:0px;bottom:" +
            //       (offsetHeight1 + 10) +
            //       "px"
            //   );
          }
          else {
            document
            .getElementsByClassName("my-location-btn")[0]
            .setAttribute("style", "bottom:" + (offsetHeight1 + 5) + "px;");
          document
            .getElementsByClassName("buttom-set-mobile")[0]
            .setAttribute("style", "bottom:" + (offsetHeight1 + 10) + "px;");
          document
            .getElementsByClassName("navigation-class")[0]
            .setAttribute(
              "style",
              "left:0px;bottom:" +
                (offsetHeight1 + 10) +
                "px"
            );
          // document
          //   .getElementsByClassName("navigation-class")[1]
          //   .setAttribute(
          //     "style",
          //     "left:0px;bottom:" +
          //       (offsetHeight1 + 10) +
          //       "px"
          //   );
          }
        }, 200);
        this.dynamicHight();
      });
      this.eventBus.$on("settingsviewshowhide", () => {
        this.settingsModal = false;
        this.dialog = true;
        setTimeout(() => {
          this.dynamicHight();
          this.dynamicWidth();
        }, 100);
      });
      this.eventBus.$on('addInsertHostportLinkClickable', () => {
        this.inserthostportlink = false
      });
      this.eventBus.$on("settingsviewhide", () => {
        this.settingsModal = false;
        setTimeout(() => {
          this.dialog = false;
        }, 100);
      });
      this.eventBus.$on("inputPlacehide", () => {
        this.dialog = false;
      });
      this.eventBus.$on("inputPlaceshow", () => {
        // if(this.settingsModal) {

        // }else {
        this.dialog = true;
        // }
      });
      this.eventBus.$on("checkPlaceData", data => {
        this.checkPlaceData = data;
      });
      this.eventBus.$on("startingPlace", data => {
        this.place = data;
      });
      this.eventBus.$on("destinationPlace", data => {
        this.place2 = data;
      });
      this.eventBus.$on("hidedropdown", () => {
        this.focused = false;
        this.focusedsecond = false;
        setTimeout(() => {
          this.eventBus.$emit('hostportModalCloseOpenDropdwon',false)
        }, 300);
      });
      this.eventBus.$on("checkplacevalue", () => {
        this.checkplacevalue = false;
      });
      this.eventBus.$on("navigationStart", () => {
        this.navigationButton = true;
      });
      this.eventBus.$on("navigationStop", () => {
        this.navigationButton = false;
      });
      this.eventBus.$on("mobilecountryCheckshow", () => {
        this.countryCheck = true;
      });
      this.eventBus.$on("mobilecountryCheckHide", () => {
        this.countryCheck = false;
      });
      this.eventBus.$on("showLoadingRoute", value => {
        this.showLoading = value;
      });
      // this.eventBus.$on('checkRoutedrawplacetwodata', () => {
      //     this.checkRoutedrawplacetwo = true
      //   })
    },
    count_starting_point_clicks() {
      this.$gtag.event("starting_point_click", {
        event_category: "route",
        event_label: "Starting point clicks",
        value: "starting_point_click"
      });
    },
    count_destination_point_clicks() {
      this.$gtag.event("destination_point_click", {
        event_category: "route",
        event_label: "Destination point clicks",
        value: "destination_point_click"
      });
    },
    count_download_route_clicks() {
      this.$gtag.event("download_route_clicks", {
        event_category: "settings",
        event_label: "Download planned route clicks",
        value: "download_route_clicks"
      });
    },
    count_balanced_route_clicks() {
      this.$gtag.event("balanced_route_clicks", {
        event_category: "settings",
        event_label: "Balanced route setting clicks",
        value: "balanced_route_clicks"
      });
    },
    count_safest_route_clicks() {
      this.$gtag.event("safest_route_clicks", {
        event_category: "settings",
        event_label: "Safest route setting clicks",
        value: "safest_route_clicks"
      });
    },
    count_fastest_route_clicks() {
      this.$gtag.event("fastest_route_clicks", {
        event_category: "settings",
        event_label: "Fastest route setting clicks",
        value: "fastest_route_clicks"
      });
    },
    // Hosport Insert Link
    addHosportInsertLink () {
      this.eventBus.$emit('tooptipShow')
      this.inserthostportlink = false
      this.eventBus.$emit('cursorAddHostPort',true)
      this.eventBus.$emit("hidedropdown");
      this.eventBus.$emit("inputPlaceshow");
      this.eventBus.$emit("buttonstoggleshowonly");
      this.eventBus.$emit("settingsButton");
      this.eventBus.$emit("settingsviewshowhide");
    },
    //remove Hosport Insert Link
    removeHosportInsertLink () {
      this.inserthostportlink = true
      this.eventBus.$emit('tooltopClose')
      this.eventBus.$emit('cursorAddHostPort',false)
    },



    /**
     * Set the default filename and format and open the download modal
     */
     openDownload () {
      this.downloadFileName = this.defaultDownloadName
      this.downloadFormat = this.downloadFormats[0].value
      this.isDownloadModalOpen = true
    },
    /**
     * Close the download modal
     */
    closeDownload () {
      this.isDownloadModalOpen = false
    },
    /**
     * Build the string download content and force a native browser download
     */
    download (fileformat,fileExt) {
      this.downloadFormat = fileformat
      this.$gtag.event(fileformat+'_download_click', {
        'event_category': 'download',
        'event_label': 'Download route with format '+fileformat,
        'value': fileformat+'_download_click'
      })
      const context = this
      this.showInfo(this.$t('download.preparingDownload'), { timeout: 0 })
      setTimeout(() => {
        
        this.buildContent().then((content) => {
          // The way to force a native browser download of a string is by
          // creating a hidden anchor and setting its href as a data text
          const link = document.createElement('a')
          link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(content)
  
          // Check if it has reached the max length
          if (link.href.length > 2097152) {
            this.showError(this.$t('download.fileTooBigToBeDownloaded'), { timeout: 2000 })
          } else {
            // Set the filename
            const timestamp = new Date().getTime()
            const format = context.lodash.find(fileformat, (df) => { return df.value === fileformat })
            // If the file has the default name, add a unique timestamp
            if (this.$store.getters.dangeruousPoints === '2') {
              this.downloadFileName = 'cycleai_shortest_route'
            }
            else  if (this.$store.getters.dangeruousPoints === '3') {
              this.downloadFileName = 'cycleai_balanced_route'
            }
            else  if (this.$store.getters.dangeruousPoints === '4') {
              this.downloadFileName = 'cycleai_safest_route'
            }
            if (this.downloadFileName === this.defaultDownloadName) {
              link.download = `${context.downloadFileName}_${timestamp}.${fileExt}`
            } else {
              link.download = `${context.downloadFileName}.${fileExt}`
            }
  
            // Fire the download by triggering a click on the hidden anchor
            document.body.appendChild(link)
            link.click()
            link.remove()
            this.showSuccess(this.$t('download.fileReady'), { timeout: 2000 })
            this.closeDownload()
          }
        }).catch(error => {
          console.error(error)
          this.showError(this.$t('download.errorPreparingFile'), { timeout: 2000 })
        })
      }, 1000);
    },
    /**
     * Build the content to be downloaded according the format selected
     * When the format is ors-gpx a new request is made using the same
     * args object but changing the format to gpx
     * @returns {Promise}
     */
    buildContent () {

      let jsonData
      const context = this
      return new Promise((resolve, reject) => {
        try {
          if (context.downloadFormat === 'json') {
            // Get the ORS mapViewData model and stringify it
            const orsJSONStr = JSON.stringify(this.mapViewData)
            resolve(orsJSONStr)
          } else if (context.downloadFormat === 'ors-gpx') {
            // If the format is ors-gpx, run anew request with the format being 'gpx'
            context.getORSGpx().then((orsGpx) => {
              resolve(orsGpx)
            }).catch(error => {
              reject(error)
            })
          } else if (context.downloadFormat === 'to-gpx') {
            const geoJSON = context.mapViewData.getGeoJson()
            // Use the third party utility to convert geojson to gpx
            const toGPX = toGpx(geoJSON)
            resolve(toGPX)
          } else if (context.downloadFormat === 'geojson') {
            jsonData = context.mapViewData.getGeoJson()
            const jsonStr = JSON.stringify(jsonData)
            resolve(jsonStr)
          } else if (context.downloadFormat === 'kml') {
            const routeTitle = context.originName.length > 0 ? `${context.originName} -> ${context.destinationName}` : context.$t('download.documentTitle')
            const kmlOptions = {
              documentName: routeTitle,
              documentDescription: constants.orsKmlDocumentDescription
            }
            jsonData = context.mapViewData.getGeoJson()
            // Use the third party utility to convert geojson to kml
            const toKML = toKml(jsonData, kmlOptions)
            resolve(toKML)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    /**
     * Get the response data routes and make sure that the geometry format is geojson
     * @returns {Array} of route objects
     */
    getOrsRoutesJson () {
      let orsRoutes = []
      // Retrieve the route data
      if (this.mapViewData && this.mapViewData.routes) {
        orsRoutes = Object.assign({}, this.mapViewData.routes)
      }
      return orsRoutes
    },

    /**
     * Get the ors gpx text running a new request
     * using the same args but changing the format to `gpx`
     * @returns {Promise}
     */
    getORSGpx () {
      const context = this
      return new Promise((resolve) => {
        // Build the args for a directions api request
        let args = OrsParamsParser.buildRoutingArgs(context.mapViewData.places)
        // merge the args with the ones applied in the user request
        args = Object.assign(args, context.mapViewData.rawData.metadata.query)

        // Make sure a gpx format will be returned
        args.format = 'gpx'

        Directions(context.mapViewData.places, args).then(response => {
          resolve(response.content)
        }).catch(result => {
          console.log(result)
        })
      })
    }
  },
  created() {
    // this.dynamicHight();
    this.setEventListeners();
    this.ratingfunction();
    this.dangeruousValue("3");
    
  },
  mounted() {
    setTimeout(() => {
      document
        .getElementById("autocomplete1")
        .addEventListener("focusout", this.myFunction());
    }, 1000);
    document.getElementsByClassName('v-dialog__content--active')[0].setAttribute("style","z-index:190;")
    setTimeout(() => {
      this.dynamicHight();
    }, 1000);
    const autocomplete2 = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete2")
    );
    autocomplete2.setComponentRestrictions({
      country: ["uk", "pt", "cz"]
    });
    autocomplete2.addListener("place_changed", () => {
      const place = autocomplete2.getPlace();
      let country;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (addressType == "country") {
          country = place.address_components[i].long_name;
        }
      }
      let places = new Place(
        place.geometry.location.lng(),
        place.geometry.location.lat(),
        place.name,
        { properties: { layer: "venue", country: country } }
      );
      this.routeSwapFieldOne = places;
      this.eventBus.$emit("GoogleAPI", places, 0);
      this.eventBus.$emit("RoutePlaceOne", places);
      this.eventBus.$emit("girastationone", {
        lat: places.lat,
        lng: places.lng
      });
      this.eventBus.$emit("destinationPlace", places.placeName);
      this.eventBus.$emit("placelatlngobj", places);
      this.routedrowdirection = true;
      // this.eventBus.$emit('routeHideInMap')
      setTimeout(() => {
        this.calculate = true;
      }, 100);
      setTimeout(() => {
        this.dynamicHight();
        this.dynamicWidth();
      }, 50);
      document.getElementsByClassName("text-fields2")[0].style.marginBottom =
        "unset";
      this.checkplace2value = false;
      // this.selected()
      // this.$forceUpdate()
    });
    const autocomplete1 = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete1")
    );
    autocomplete1.setComponentRestrictions({
      country: ["uk", "pt","in","cz"]
    });
    autocomplete1.addListener("place_changed", () => {
      const place = autocomplete1.getPlace();
      let country;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (addressType == "country") {
          country = place.address_components[i].long_name;
        }
      }
      let places = new Place(
        place.geometry.location.lng(),
        place.geometry.location.lat(),
        place.name,
        { properties: { layer: "venue", country: country } }
      );
      this.eventBus.$emit("routeSwapFieldSecond", places);
      this.eventBus.$emit("GoogleAPI", places, 1);
      this.eventBus.$emit("RoutePlaceSecond", places);
      this.eventBus.$emit("girastationsecond", {
        lat: places.lat,
        lng: places.lng
      });
      this.eventBus.$emit("startingPlace", places.placeName);
      this.eventBus.$emit("textfieldshow");
      this.showSecondTextFeild = true;
      if(this.routeCheckMobile) {
        this.routedrowdirection = true;
      }
      setTimeout(() => {
        this.eventBus.$emit("calculateButtom");
      }, 300);
      setTimeout(() => {
        this.eventBus.$emit("dynamicHight");
        this.eventBus.$emit("dynamicWidth");
      }, 50);
      document.getElementsByClassName("text-fields1")[0].style.marginBottom =
        "unset";
      this.eventBus.$emit("checkplacevalue");
      // this.selected()
      this.$forceUpdate();
    });
  }
};
